import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { ReactComponent as SvgFacebook } from '@img/icons/facebook-circle.svg';
import { ReactComponent as SvgLinkedIn } from '@img/icons/linkedin-circle.svg';
import { ReactComponent as SvgInstagram } from '@img/icons/instagram.svg';
import { ReactComponent as SvgTwitter } from '@img/icons/x-logo-circle.svg';
import styled from 'styled-components';
import { cssVar, setCssVar } from '@helpers/cssVar';
const LogoIcon = styled.img `
  position: absolute;

  .theme-hta & {
    display: none;
  }
`;
const LogoIconBg = styled.img `
  position: absolute;

  .theme-hta & {
    display: none;
  }
`;
const Container = styled.footer `
  ${setCssVar('bgColor', brand.grey)};
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('fgColorAlt', brand.hta.green)};

  color: ${cssVar('fgColor')};
  background-color: ${cssVar('bgColor')};
  overflow: hidden;
  border-top: 12px solid ${cssVar('fgColorAlt')};
  padding-top: 25px;
  padding-bottom: 25px;
  position: relative;

  @media ${from(Device.TabletLarge)} {
    padding-top: 40px;
  }

  ${LogoIconBg} {
    width: 348px;
    height: 281px;
    bottom: -60px;
    right: -80px;
    transform: rotate(-34deg);

    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }

  .theme-hta & {
    min-height: 539px;
  }

  .theme-apl & {
    ${setCssVar('bgColor', brand.white)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.apl.green)};

    ${LogoIconBg} {
      bottom: -30px;
      right: -100px;
      transform: rotate(0deg);
    }
  }

  .theme-hh & {
    ${setCssVar('bgColor', brand.grey)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.hortHouse.green)};

    ${LogoIconBg} {
      width: 250px;
      height: 188px;
      bottom: 0;
      right: 0;
      transform: rotate(0deg);
    }
  }

  .theme-rss & {
    ${setCssVar('bgColor', brand.black)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.rss.green)};

    ${LogoIcon} {
      display: none;
    }

    ${LogoIconBg} {
      width: 260px;
      height: 164px;
      bottom: 39px;
      right: 0;
      transform: rotate(0deg);
    }
  }
`;
const Background = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  display: none;

  .theme-hta & {
    display: block;
  }
`;
const Inner = styled.div `
  position: relative;
`;
const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(24, 1fr);
    gap: 32px;
  }
`;
const Col = styled.div `
  grid-column: span 12;
  text-align: center;

  @media ${from(Device.TabletLarge)} {
    grid-column: span 4;
    text-align: left;
  }

  &:last-child {
    @media ${from(Device.TabletLarge)} {
      grid-column: 17 / span 6;
    }

    @media ${from(Device.Desktop)} {
      grid-column: 19 / span 4;
    }
  }
`;
const LogoHolder = styled.a `
  display: block;
  margin-bottom: 0;

  @media ${until(Device.TabletLarge)} {
    margin-bottom: 40px;
    text-align: center;
  }
`;
const Logo = styled.img `
  width: 94px;
  height: 72px;

  @media ${from(Device.TabletLarge)} {
    width: 140px;
    height: 107px;
  }

  .theme-apl & {
    width: 212px;
    height: 72px;

    @media ${from(Device.TabletLarge)} {
      width: 232px;
      height: 78px;
    }
  }
`;
const Legal = styled.div `
  margin-top: 40px;
  grid-column: span 12;
  position: relative;
  width: 100%;

  @media ${from(Device.TabletLarge)} {
    width: calc(100% - 260px);
  }

  @media ${from(Device.ActualDesktop)} {
    width: calc(100% - 150px);
  }

  ${LogoIcon} {
    height: 22px;
    width: 27px;
    left: 20px;
    bottom: 100%;

    @media ${until(Device.TabletLarge)} {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .theme-apl & {
    ${LogoIcon} {
      background-color: ${cssVar('bgColor')};
      left: 0;
      transform: translateX(0);
      bottom: auto;
      top: -11px;
      @media ${from(Device.TabletLarge)} {
        display: none;
      }
    }
  }

  .theme-hh & {
    ${LogoIcon} {
      display: none;
    }
  }
`;
const LegalInner = styled.div `
  border-top: 1px solid ${cssVar('fgColorAlt')};
  padding-top: 20px;

  .theme-hta & {
    border-top: none;
  }
`;
const LegalContent = styled.p `
  ${fonts.sourceSansPro.regular}
  color: ${cssVar('fgColor')};
  font-size: 16px;
  line-height: 26px;

  @media ${until(Device.TabletLarge)} {
    text-align: center;
    font-size: 14px;
    line-height: 24px;
  }
`;
const SocialTitle = styled.h4 `
  ${fonts.sourceSansPro.semiBold}
  color: ${cssVar('fgColor')};
  font-size: 20px;
  line-height: 34px;
  margin-bottom: 20px;
`;
const SocialHolder = styled.div `
  margin-bottom: 20px;
`;
const SocialLink = styled.a ``;
const FacebookIcon = styled(SvgFacebook) `
  color: ${cssVar('fgColor')};
  width: 40px;
  height: 40px;
  margin-right: 7px;

  .theme-apl & {
    color: ${cssVar('fgColorAlt')};
  }
`;
const LinkedinIcon = styled(SvgLinkedIn) `
  color: ${cssVar('fgColor')};
  width: 40px;
  height: 40px;

  .theme-apl & {
    color: ${cssVar('fgColorAlt')};
  }
`;
const InstagramIcon = styled(SvgInstagram) `
  color: ${cssVar('fgColor')};
  width: 40px;
  height: 40px;
  margin-right: 7px;

  .theme-apl & {
    color: ${cssVar('fgColorAlt')};
  }
`;
const TwitterIcon = styled(SvgTwitter) `
  color: ${cssVar('fgColor')};
  width: 40px;
  height: 40px;
  margin-right: 7px;

  .theme-apl & {
    color: ${cssVar('fgColorAlt')};
  }
`;
export default {
    Background,
    Col,
    Container,
    FacebookIcon,
    Grid,
    Inner,
    InstagramIcon,
    Legal,
    LegalContent,
    LegalInner,
    LinkedinIcon,
    Logo,
    LogoHolder,
    LogoIcon,
    LogoIconBg,
    SocialHolder,
    SocialLink,
    SocialTitle,
    TwitterIcon,
};
